/**
 * 앱 크롬(사이드바) 상태 — 편집기 스토어에서 분리(트랙 A-4, docs/DESIGN-perf-track.md §2).
 *
 * 진입 페이지(픽커·플랫폼 홈)가 사이드바 펼침 하나 때문에 편집기 스토어를 정적으로 가져오면
 * MARS·Modelica 도메인 전체가 진입 청크에 실린다(실측 516KB+). 크롬 상태는 어느 페이지에나
 * 있으므로 도메인이 없는 작은 스토어가 소유한다. 영속 키는 새 이름(레거시 마이그레이션 없음).
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UiChromeState {
  sidebarExpanded: boolean;
  setSidebarExpanded: (expanded: boolean) => void;
  toggleSidebar: () => void;
}

export const useUiChromeStore = create<UiChromeState>()(
  persist(
    (set, get) => ({
      sidebarExpanded: true,
      setSidebarExpanded: (expanded) => set({ sidebarExpanded: expanded }),
      toggleSidebar: () => set({ sidebarExpanded: !get().sidebarExpanded }),
    }),
    { name: 'vsmr-ui-chrome' },
  ),
);
